import type { ReportDropDownProps } from './report-dropdown.interface';

import classNames from 'classnames';
import { memo, useState } from 'react';

import ReportService from '../../services/reports.service';
import { Spinner } from '../template/spinner/spinner';

const reportService = new ReportService();

export const ReportDropDown = memo(
  ({ item, name, renderDropdown, children }: ReportDropDownProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [entityData, setEntityData] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const { id } = item;

    const changeState = () => {
      const shouldFetchData = Boolean(!isExpanded && !entityData && id && name);

      if (shouldFetchData) {
        setLoading(true);
        reportService
          .getShortReport(id, name)
          .then((res) => {
            setEntityData(res);
          })
          .finally(() => {
            setLoading(false);
          });
      }

      setIsExpanded((prev) => !prev);
    };

    const renderReport = () => renderDropdown(entityData);

    return (
      <div className="dropdown">
        <div className="dropdown-toggle" onClick={changeState}>
          <p className="dropdown-toggle__name">
            <i
              className={classNames(
                'dropdown-toggle__icon',
                isExpanded && 'is-active',
              )}
            />
            {item.title}
          </p>
        </div>
        <div
          className={classNames(
            'dropdown-content',
            isExpanded && 'is-expanded',
          )}
        >
          {loading ? (
            <Spinner />
          ) : (
            entityData && (
              <>
                {renderReport()}
                {children}
              </>
            )
          )}
        </div>
      </div>
    );
  },
);

ReportDropDown.displayName = 'ReportDropDown';
